import createBrowserHistory from 'history/createBrowserHistory'
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router'
import { AppBarStore } from './app-bar/app-bar-store'
import { AppStore } from './app/app-store'
import { LoginStore } from './login/login-store'
import { MonitoringStore } from './monitoring/monitoring-store'
import { NavigationMenuStore } from './navigation-menu/navigation-menu-store'
import { getStore, putStore } from './stores-repository'
import { UserStore } from './user/user-store'
import { ViolationLogStore } from './violation-log/violation-log-store'
import {
    ALL_STORES,
    APP_BAR_STORE,
    APP_STORE,
    LOGIN_STORE,
    MONITORING_STORE,
    NAVIGATION_MENU_STORE,
    ROUTING_STORE,
    VIOLATION_LOG_STORE,
    USER_STORE,
} from './stores'
import { getBaseURL } from '../utils/router-utils'

const browserHistory = createBrowserHistory({
    basename: getBaseURL()
})

putStore(ROUTING_STORE, new RouterStore())

export const history = syncHistoryWithStore(browserHistory, getStore(ROUTING_STORE))

putStore(APP_STORE, new AppStore())
putStore(APP_BAR_STORE, new AppBarStore())
putStore(USER_STORE, new UserStore())
putStore(NAVIGATION_MENU_STORE, new NavigationMenuStore())
putStore(LOGIN_STORE, new LoginStore())
putStore(MONITORING_STORE, new MonitoringStore())
putStore(VIOLATION_LOG_STORE, new ViolationLogStore())

export const createStore = () => {
    const store = {}
    ALL_STORES.forEach(storeName => {
        store[storeName] = getStore(storeName)
    })
    return store
}
